/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:53:32.

export interface ApproveUserInvokeRequestDto {
    invokeId: string;
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface CreateAgentDto {
    id: string;
    name: string;
    isActive: boolean;
}

export interface CreateAgentDebtRiskDefaultServiceSupportAdditionInvokeDto {
    agentId: string;
    currency: string;
}

export interface CreateAgentRiskDownPaymentSetInvokeRequestDto {
    agentId: string;
    downPayment: number;
    currency: string;
    serviceCode: string;
}

export interface CreateAgentDebtRiskServiceSupportAdditionInvokeDto {
    agentId: string;
    currency: string;
    serviceCode: string;
}

export interface CreateAgentRiskTemporaryDebtLimitIncreaseAdditionInvokeRequestDto {
    temporaryDebtLimitIncrease: TemporaryDebtLimitIncrease;
    agentId: string;
    currency: string;
    serviceCode: string;
}

export interface CreateAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvokeRequestDto {
    temporaryDebtLimitId: string;
    agentId: string;
    currency: string;
    serviceCode: string;
}

export interface CreateAgentRiskRequestDto {
    agentId: string;
    agentDebtRiskType: AgentDebtRiskType;
    defaultRiskStateCurrency: string;
}

export interface DecreaseDebtRequestDto {
    agentId: string;
    amount: number;
    requestId: string;
    currency: string;
    locationId: string;
    serviceCode: string;
}

export interface IncreaseDebtRequestDto {
    agentId: string;
    amount: number;
    requestId: string;
    currency: string;
    locationId: string;
    serviceCode: string;
}

export interface RejectUserInvokeRequestDto {
    invokeId: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface SetBaseDebtLimitRequestDto {
    agentId: string;
    baseDebtLimit: number;
    currency: string;
    serviceCode: string;
}

export interface UpdateAgentDto {
    id: string;
    name: string;
    isActive: boolean;
    deleted: boolean;
}

export interface CreateAgentRiskDebtLimitModelAssignmentInvokeRequestDto {
    agentId: string;
    debtLimitModelId: string;
}

export interface CreateDebtLimitDefaultServiceModelCreationRequestRequestDto {
    debtLimitModelId: string;
    name: string;
    description: string;
    baseDebtLimit: number;
    currency: string;
    hasPlannedIncrease: boolean;
}

export interface CreateDebtLimitModelCreationRequestRequestDto {
    debtLimitModelId: string;
    name: string;
    description: string;
    baseDebtLimit: number;
    currency: string;
    serviceCode: string;
    hasPlannedIncrease: boolean;
}

export interface CreateDebtLimitModelDeactivationInvocationRequestDto {
    debtLimitModelId: string;
}

export interface CreateDebtLimitModelDeletionInvocationRequestDto {
    debtLimitModelId: string;
}

export interface CreateDebtLimitModelPlannedDebtLimitIncreaseAdditionInvokeRequestDto {
    debtLimitModelId: string;
    plannedDebtLimitIncrease: PlannedDebtLimitIncrease;
}

export interface CreateDebtLimitModelPlannedDebtLimitIncreaseRemovalInvokeRequestDto {
    debtLimitModelId: string;
    plannedDebtLimitIncreaseId: string;
    currency: string;
}

export interface SearchRequest extends Serializable {
    filters: FilterRequest[];
    sorts: SortRequest[];
    page: number;
    size: number;
}

export interface ActivateLocationDebtRiskRequestDto {
    agentId: string;
    locationId: string;
}

export interface WebStringResponse extends WebResponseEntity<string> {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface AddLocationDebtRiskForCurrencyRequestDto {
    agentId: string;
    locationId: string;
    currency: string;
    locationDebtLimit: number;
    locationDebt: number;
}

export interface CreateLocationDebtRiskRequestDto {
    agentId: string;
    locationId: string;
    locationDebtRiskName: string;
    serviceBlocking: boolean;
    agentDebtRiskCurrencyType: AgentDebtRiskCurrencyType;
    domicileCurrency: string;
}

export interface DeactivateLocationDebtRiskRequestDto {
    agentId: string;
    locationId: string;
}

export interface DecreaseLocationDebtForCurrencyRequestDto {
    agentId: string;
    locationId: string;
    currency: string;
    amount: number;
}

export interface DeleteLocationDebtRiskRequestDto {
    agentId: string;
    locationId: string;
}

export interface IncreaseLocationDebtForCurrencyRequestDto {
    agentId: string;
    locationId: string;
    currency: string;
    amount: number;
}

export interface RemoveLocationDebtRiskForCurrencyRequestDto {
    agentId: string;
    locationId: string;
    currency: string;
}

export interface UpdateLocationDebtLimitForCurrencyRequestDto {
    agentId: string;
    locationId: string;
    currency: string;
    limitAmount: number;
}

export interface UpdateLocationDebtRiskRequestDto {
    agentId: string;
    locationId: string;
    locationDebtRiskName: string;
    serviceBlocking: boolean;
    agentDebtRiskCurrencyType: AgentDebtRiskCurrencyType;
    domicileCurrency: string;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface AgentRisk {
    agentId: string;
    agentDebtRiskType: AgentDebtRiskType;
    defaultRiskStateCurrency: string;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface TemporaryDebtLimitIncrease extends DebtLimitIncrease {
    id: string;
    increaseValue: number;
    validFrom: DateAsString;
    validDue: DateAsString;
    debtLimitIncreaseStrategy: DebtLimitIncreaseStrategyType;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface AgentCommonDto {
    id: string;
    name: string;
    isActive: boolean;
    deleted: boolean;
}

export interface AgentDebtRiskDto {
    agentId: string;
    serviceCode: string;
    currency: string;
    debtLimitModelId: string;
    baseDebtLimit: number;
    actualDebtLimit: number;
    downPayment: number;
    agentDebt: number;
    planedDebtLimitIncreases: PlannedDebtLimitIncreaseDto[];
    temporaryDebtLimitIncreases: TemporaryDebtLimitIncreaseDto[];
}

export interface PlannedDebtLimitIncrease {
    id: string;
    increaseValue: number;
    debtLimitIncreaseStrategy: DebtLimitIncreaseStrategyType;
    debtLimitIncreaseType: PlannedDebtLimitIncreaseType;
    validFrom: DateAsString;
    validDue: DateAsString;
    validOnPeriods: PlannedDebtLimitIncreasePeriod[];
    validOnMonthDays: PlannedDebtLimitIncreaseMonthDay[];
    validOnWeekDays: number[];
}

export interface DebtRiskLimitModelDto {
    debtLimitModelId: string;
    name: string;
    description: string;
    baseDebtLimit: number;
    currency: string;
    serviceCode: string;
    hasPlannedIncrease: boolean;
    hasActiveInvoke: boolean;
    debtLimitModelStatusType: DebtLimitModelStatusType;
    planedDebtLimitIncreases: PlannedDebtLimitIncreaseDto[];
    assignedToAgents: string[];
    allowedCommands: DebtLimitModelCommandType[];
}

export interface FilterRequest extends Serializable {
    key: string;
    operator: Operator;
    field_type: FieldType;
    value: any;
    value_to: any;
    values: any[];
}

export interface SortRequest extends Serializable {
    key: string;
    direction: SortDirection;
}

export interface Serializable {
}

export interface Page<T> extends Slice<T> {
    totalPages: number;
    totalElements: number;
}

export interface LocationDebtRiskResponseDto {
    locationDebtRiskId: string;
    agentId: string;
    locationId: string;
    locationDebtRiskName: string;
    serviceBlocking: boolean;
    isActive: boolean;
    activateOn: DateAsString;
    deactivateOn: DateAsString;
    agentDebtRiskCurrencyType: AgentDebtRiskCurrencyType;
    domicileCurrency: string;
    locationDebtRiskByCurrencyList: LocationDebtRiskByCurrency[];
}

export interface UserInvoke {
    id: string;
    invokedBy: string;
    invokedOn: DateAsString;
    resolvedBy: string;
    resolvedOn: DateAsString;
    invokeStatusType: InvokeStatusType;
    invokeType: InvokeType;
    data: string;
    relatedEntityId: string;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface DebtLimitIncrease {
}

export interface PlannedDebtLimitIncreaseDto {
    id: string;
    increaseValue: number;
    debtLimitIncreaseStrategy: DebtLimitIncreaseStrategyType;
    debtLimitIncreaseType: PlannedDebtLimitIncreaseType;
    validFrom: string;
    validDue: string;
    validOnPeriods: PlannedDebtLimitIncreasePeriod[];
    validOnMonthDays: PlannedDebtLimitIncreaseMonthDay[];
    validOnWeekDays: number[];
}

export interface TemporaryDebtLimitIncreaseDto {
    id: string;
    increaseValue: number;
    validFrom: string;
    validDue: string;
    debtLimitIncreaseStrategy: DebtLimitIncreaseStrategyType;
}

export interface PlannedDebtLimitIncreasePeriod {
    periodFrom: DateAsString;
    periodTo: DateAsString;
}

export interface PlannedDebtLimitIncreaseMonthDay {
    monthDayType: MonthDayType;
    day: number;
}

export interface Sort extends Streamable<Order>, Serializable {
    sorted: boolean;
    unsorted: boolean;
}

export interface Pageable {
    offset: number;
    sort: Sort;
    paged: boolean;
    unpaged: boolean;
    pageNumber: number;
    pageSize: number;
}

export interface LocationDebtRiskByCurrency {
    currency: string;
    locationDebtLimit: number;
    locationDebt: number;
    actualLimit: number;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface Slice<T> extends Streamable<T> {
    size: number;
    content: T[];
    number: number;
    sort: Sort;
    last: boolean;
    first: boolean;
    numberOfElements: number;
    pageable: Pageable;
}

export interface Streamable<T> extends Iterable<T>, Supplier<Stream<T>> {
    empty: boolean;
}

export interface Order extends Serializable {
    direction: Direction;
    property: string;
    ignoreCase: boolean;
    nullHandling: NullHandling;
    ascending: boolean;
    descending: boolean;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface Iterable<T> {
}

export interface Supplier<T> {
}

export interface Stream<T> extends BaseStream<T, Stream<T>> {
}

export interface BaseStream<T, S> extends AutoCloseable {
    parallel: boolean;
}

export interface AutoCloseable {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /risk/agent-debt/agent-debt-risks
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAgentDebtRisks
     */
    getAgentDebtRisks(options?: O): RestResponse<WebListResponseEntity<AgentDebtRiskDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/agent-debt-risks`, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/agent-debt-risks-by-agent
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAgentDebtRisksByAgent
     */
    getAgentDebtRisksByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<AgentDebtRiskDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/agent-debt-risks-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/agent-risk-by-agent
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAgentRiskByAgent
     */
    getAgentRiskByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebResponseEntity<AgentRisk>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/agent-risk-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/all-agent-risks
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.allAgentRisks
     */
    allAgentRisks(options?: O): RestResponse<WebListResponseEntity<AgentRisk>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/all-agent-risks`, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/approve-agent-debt-risk-down-payment-set-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.approveAgentDebtRiskDownPaymentSetInvoke
     */
    approveAgentDebtRiskDownPaymentSetInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/approve-agent-debt-risk-down-payment-set-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/approve-agent-debt-risk-service-support-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.approveAgentDebtRiskServiceSupportAdditionInvoke
     */
    approveAgentDebtRiskServiceSupportAdditionInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/approve-agent-debt-risk-service-support-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/approve-agent-debt-risk-service-support-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.approveAgentDebtRiskServiceSupportRemovalInvoke
     */
    approveAgentDebtRiskServiceSupportRemovalInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/approve-agent-debt-risk-service-support-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/approve-agent-debt-risk-temporary-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.approveAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke
     */
    approveAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/approve-agent-debt-risk-temporary-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/approve-agent-debt-risk-temporary-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.approveAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke
     */
    approveAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/approve-agent-debt-risk-temporary-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgent
     */
    createAgent(req: CreateAgentDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-default-service-support-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskDefaultServiceSupportAdditionInvoke
     */
    createAgentDebtRiskDefaultServiceSupportAdditionInvoke(req: CreateAgentDebtRiskDefaultServiceSupportAdditionInvokeDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-default-service-support-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-down-payment-set-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskDownPaymentSetInvoke
     */
    createAgentDebtRiskDownPaymentSetInvoke(req: CreateAgentRiskDownPaymentSetInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-down-payment-set-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-service-support-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskServiceSupportAdditionInvoke
     */
    createAgentDebtRiskServiceSupportAdditionInvoke(req: CreateAgentDebtRiskServiceSupportAdditionInvokeDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-service-support-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-service-support-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskServiceSupportRemovalInvoke
     */
    createAgentDebtRiskServiceSupportRemovalInvoke(req: CreateAgentDebtRiskServiceSupportAdditionInvokeDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-service-support-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-temporary-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke
     */
    createAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke(req: CreateAgentRiskTemporaryDebtLimitIncreaseAdditionInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-temporary-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-debt-risk-temporary-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke
     */
    createAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke(req: CreateAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-debt-risk-temporary-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/create-agent-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.createAgentRisk
     */
    createAgentRisk(req: CreateAgentRiskRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/create-agent-risk`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/decrease-debt
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.decreaseDebt
     */
    decreaseDebt(req: DecreaseDebtRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/decrease-debt`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/decrease-debt-booking
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.decreaseDebtBooking
     */
    decreaseDebtBooking(req: DecreaseDebtRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/decrease-debt-booking`, data: req, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/get-agent
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAgent
     */
    getAgent(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<AgentCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/get-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/get-all-active-agents
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAllActiveAgents
     */
    getAllActiveAgents(options?: O): RestResponse<WebListResponseEntity<AgentCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/get-all-active-agents`, options: options });
    }

    /**
     * HTTP GET /risk/agent-debt/get-all-agents
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.getAllAgents
     */
    getAllAgents(options?: O): RestResponse<WebListResponseEntity<AgentCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/agent-debt/get-all-agents`, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/increase-debt
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.increaseDebt
     */
    increaseDebt(req: IncreaseDebtRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/increase-debt`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/increase-debt-booking
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.increaseDebtBooking
     */
    increaseDebtBooking(req: IncreaseDebtRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/increase-debt-booking`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-agent-debt-risk-down-payment-set-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAgentDebtRiskDownPaymentSetInvoke
     */
    rejectAgentDebtRiskDownPaymentSetInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-agent-debt-risk-down-payment-set-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-agent-debt-risk-service-support-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAgentDebtRiskServiceSupportAdditionInvoke
     */
    rejectAgentDebtRiskServiceSupportAdditionInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-agent-debt-risk-service-support-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-agent-debt-risk-service-support-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAgentDebtRiskServiceSupportRemovalInvoke
     */
    rejectAgentDebtRiskServiceSupportRemovalInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-agent-debt-risk-service-support-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-agent-debt-risk-temporary-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke
     */
    rejectAgentDebtRiskTemporaryDebtLimitIncreaseAdditionInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-agent-debt-risk-temporary-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-agent-debt-risk-temporary-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke
     */
    rejectAgentDebtRiskTemporaryDebtLimitIncreaseRemovalInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-agent-debt-risk-temporary-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/reject-all-debt-booking-requests
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.rejectAllDebtBookingRequests
     */
    rejectAllDebtBookingRequests(options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/reject-all-debt-booking-requests`, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/set-base-debt-limit
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.setBaseDebtLimit
     */
    setBaseDebtLimit(req: SetBaseDebtLimitRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/set-base-debt-limit`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/agent-debt/update-agent
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.AgentRiskController.updateAgent
     */
    updateAgent(req: UpdateAgentDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/agent-debt/update-agent`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-agent-risk-debt-limit-model-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveAgentRiskDebtLimitModelAssignmentInvoke
     */
    approveAgentRiskDebtLimitModelAssignmentInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-agent-risk-debt-limit-model-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-agent-risk-debt-limit-model-remove-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveAgentRiskDebtLimitModelRemoveAssignmentInvoke
     */
    approveAgentRiskDebtLimitModelRemoveAssignmentInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-agent-risk-debt-limit-model-remove-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-debt-limit-model-creation-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveDebtLimitModelCreationRequest
     */
    approveDebtLimitModelCreationRequest(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-debt-limit-model-creation-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-debt-limit-model-deactivation-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveDebtLimitModelDeactivationInvoke
     */
    approveDebtLimitModelDeactivationInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-debt-limit-model-deactivation-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-debt-limit-model-deletion-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveDebtLimitModelDeletionInvoke
     */
    approveDebtLimitModelDeletionInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-debt-limit-model-deletion-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-debt-limit-model-planned-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke
     */
    approveDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-debt-limit-model-planned-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/approve-debt-limit-model-planned-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.approveDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke
     */
    approveDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/approve-debt-limit-model-planned-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-agent-risk-debt-limit-model-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createAgentRiskDebtLimitModelAssignmentInvoke
     */
    createAgentRiskDebtLimitModelAssignmentInvoke(req: CreateAgentRiskDebtLimitModelAssignmentInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-agent-risk-debt-limit-model-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-agent-risk-debt-limit-model-remove-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createAgentRiskDebtLimitModelRemoveAssignmentInvoke
     */
    createAgentRiskDebtLimitModelRemoveAssignmentInvoke(req: CreateAgentRiskDebtLimitModelAssignmentInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-agent-risk-debt-limit-model-remove-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-default-service-model-creation-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitDefaultServiceModelCreationRequest
     */
    createDebtLimitDefaultServiceModelCreationRequest(req: CreateDebtLimitDefaultServiceModelCreationRequestRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-default-service-model-creation-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-model-creation-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitModelCreationRequest
     */
    createDebtLimitModelCreationRequest(req: CreateDebtLimitModelCreationRequestRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-model-creation-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-model-deactivation-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitModelDeactivationRequest
     */
    createDebtLimitModelDeactivationRequest(req: CreateDebtLimitModelDeactivationInvocationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-model-deactivation-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-model-deletion-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitModelDeletionRequest
     */
    createDebtLimitModelDeletionRequest(req: CreateDebtLimitModelDeletionInvocationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-model-deletion-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-model-planned-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke
     */
    createDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke(req: CreateDebtLimitModelPlannedDebtLimitIncreaseAdditionInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-model-planned-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/create-debt-limit-model-planned-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.createDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke
     */
    createDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke(req: CreateDebtLimitModelPlannedDebtLimitIncreaseRemovalInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/create-debt-limit-model-planned-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP GET /risk/debt-limit-model/debt-limit-model
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.getDebtLimitModel
     */
    getDebtLimitModel(queryParams: { debtLimitModelId: string; }, options?: O): RestResponse<WebResponseEntity<DebtRiskLimitModelDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/debt-limit-model/debt-limit-model`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/debt-limit-model/debt-limit-models
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.getDebtLimitModels
     */
    getDebtLimitModels(options?: O): RestResponse<WebListResponseEntity<DebtRiskLimitModelDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/debt-limit-model/debt-limit-models`, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-agent-risk-debt-limit-model-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectAgentRiskDebtLimitModelAssignmentInvoke
     */
    rejectAgentRiskDebtLimitModelAssignmentInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-agent-risk-debt-limit-model-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-agent-risk-debt-limit-model-remove-assignment-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectAgentRiskDebtLimitModelRemoveAssignmentInvoke
     */
    rejectAgentRiskDebtLimitModelRemoveAssignmentInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-agent-risk-debt-limit-model-remove-assignment-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-debt-limit-model-creation-invocation
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectDebtLimitModelCreationRequest
     */
    rejectDebtLimitModelCreationRequest(req: ApproveUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-debt-limit-model-creation-invocation`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-debt-limit-model-deactivation-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectDebtLimitModelDeactivationInvoke
     */
    rejectDebtLimitModelDeactivationInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-debt-limit-model-deactivation-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-debt-limit-model-deletion-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectDebtLimitModelDeletionInvoke
     */
    rejectDebtLimitModelDeletionInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-debt-limit-model-deletion-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-debt-limit-model-planned-debt-limit-increase-addition-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke
     */
    rejectDebtLimitModelPlannedDebtLimitIncreaseAdditionInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-debt-limit-model-planned-debt-limit-increase-addition-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/reject-debt-limit-model-planned-debt-limit-increase-removal-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.rejectDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke
     */
    rejectDebtLimitModelPlannedDebtLimitIncreaseRemovalInvoke(req: RejectUserInvokeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/reject-debt-limit-model-planned-debt-limit-increase-removal-invoke`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/debt-limit-model/search-all-models
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.DebtLimitModelController.searchAllModels
     */
    searchAllModels(request: SearchRequest, options?: O): RestResponse<Page<DebtRiskLimitModelDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/debt-limit-model/search-all-models`, data: request, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/activate-location-debt-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.activateLocationDebtRisk
     */
    activateLocationDebtRisk(req: ActivateLocationDebtRiskRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/activate-location-debt-risk`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/add-location-debt-risk-for-currency
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.addLocationDebtRiskForCurrency
     */
    addLocationDebtRiskForCurrency(req: AddLocationDebtRiskForCurrencyRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/add-location-debt-risk-for-currency`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/create-location-debt-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.createLocationDebtRisk
     */
    createLocationDebtRisk(req: CreateLocationDebtRiskRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/create-location-debt-risk`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/deactivate-location-debt-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.deactivateLocationDebtRisk
     */
    deactivateLocationDebtRisk(req: DeactivateLocationDebtRiskRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/deactivate-location-debt-risk`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/decrease-location-debt-for-currency
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.decreaseLocationDebtForCurrency
     */
    decreaseLocationDebtForCurrency(req: DecreaseLocationDebtForCurrencyRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/decrease-location-debt-for-currency`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/delete-location-debt-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.deleteLocationDebtRisk
     */
    deleteLocationDebtRisk(req: DeleteLocationDebtRiskRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/delete-location-debt-risk`, data: req, options: options });
    }

    /**
     * HTTP GET /risk/location-debt/get-all-active-location-debt-risks
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.getAllActiveLocationDebtRisks
     */
    getAllActiveLocationDebtRisks(options?: O): RestResponse<WebListResponseEntity<LocationDebtRiskResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/location-debt/get-all-active-location-debt-risks`, options: options });
    }

    /**
     * HTTP GET /risk/location-debt/get-all-location-debt-risks
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.getAllLocationDebtRisks
     */
    getAllLocationDebtRisks(options?: O): RestResponse<WebListResponseEntity<LocationDebtRiskResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/location-debt/get-all-location-debt-risks`, options: options });
    }

    /**
     * HTTP GET /risk/location-debt/get-location-debt-risk-by-location-id
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.getLocationDebtRiskByLocationId
     */
    getLocationDebtRiskByLocationId(queryParams: { locationId: string; }, options?: O): RestResponse<WebResponseEntity<LocationDebtRiskResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/location-debt/get-location-debt-risk-by-location-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/increase-location-debt-for-currency
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.increaseLocationDebtForCurrency
     */
    increaseLocationDebtForCurrency(req: IncreaseLocationDebtForCurrencyRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/increase-location-debt-for-currency`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/remove-location-debt-risk-for-currency
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.removeLocationDebtRiskForCurrency
     */
    removeLocationDebtRiskForCurrency(req: RemoveLocationDebtRiskForCurrencyRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/remove-location-debt-risk-for-currency`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/update-location-debt-limit-for-currency
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.updateLocationDebtLimitForCurrency
     */
    updateLocationDebtLimitForCurrency(req: UpdateLocationDebtLimitForCurrencyRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/update-location-debt-limit-for-currency`, data: req, options: options });
    }

    /**
     * HTTP POST /risk/location-debt/update-location-debt-risk
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.LocationDeptRiskController.updateLocationDebtRisk
     */
    updateLocationDebtRisk(req: UpdateLocationDebtRiskRequestDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`risk/location-debt/update-location-debt-risk`, data: req, options: options });
    }

    /**
     * HTTP GET /risk/user-invoke/active-user-invokes
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.UserInvokesController.getActiveUserInvokes
     */
    getActiveUserInvokes(options?: O): RestResponse<WebListResponseEntity<UserInvoke>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/user-invoke/active-user-invokes`, options: options });
    }

    /**
     * HTTP GET /risk/user-invoke/concurrent-active-user-invokes
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.UserInvokesController.getConcurrentActiveUserInvokes
     */
    getConcurrentActiveUserInvokes(queryParams: { relatedEntityId: string; }, options?: O): RestResponse<WebListResponseEntity<UserInvoke>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/user-invoke/concurrent-active-user-invokes`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/user-invoke/user-invoke
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.UserInvokesController.getUserInvoke
     */
    getUserInvoke(queryParams: { userInvokeId: string; }, options?: O): RestResponse<WebResponseEntity<UserInvoke>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/user-invoke/user-invoke`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /risk/user-invoke/user-invokes
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.UserInvokesController.getUserInvokes
     */
    getUserInvokes(options?: O): RestResponse<WebListResponseEntity<UserInvoke>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/user-invoke/user-invokes`, options: options });
    }

    /**
     * HTTP GET /risk/user-invoke/user-invokes-by-related-entity
     * Java method: com.europoint.risk.agentdebtwebapi.web.controllers.UserInvokesController.getUserInvokesByRelatedEntity
     */
    getUserInvokesByRelatedEntity(queryParams: { relatedEntityId: string; }, options?: O): RestResponse<WebListResponseEntity<UserInvoke>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`risk/user-invoke/user-invokes-by-related-entity`, queryParams: queryParams, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum AgentDebtRiskType {
    SINGLE_SERVICE_SINGLE_CURRENCY = "SINGLE_SERVICE_SINGLE_CURRENCY",
    SINGLE_SERVICE_MULTI_CURRENCY = "SINGLE_SERVICE_MULTI_CURRENCY",
    MULTI_SERVICE_SINGLE_CURRENCY = "MULTI_SERVICE_SINGLE_CURRENCY",
    MULTI_SERVICE_MULTI_CURRENCY = "MULTI_SERVICE_MULTI_CURRENCY",
}

export const enum AgentDebtRiskCurrencyType {
    SINGLE_CURRENCY = "SINGLE_CURRENCY",
    MULTI_CURRENCY = "MULTI_CURRENCY",
}

export const enum DebtLimitIncreaseStrategyType {
    ABSOLUTE = "ABSOLUTE",
    PERCENTAGE = "PERCENTAGE",
}

export const enum PlannedDebtLimitIncreaseType {
    EVERYDAY = "EVERYDAY",
    PERIODIC = "PERIODIC",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
}

export const enum DebtLimitModelStatusType {
    Created = "Created",
    Approved = "Approved",
    Rejected = "Rejected",
    Active = "Active",
    Inactive = "Inactive",
    Deleted = "Deleted",
}

export const enum DebtLimitModelCommandType {
    APPROVE_MODEL = "APPROVE_MODEL",
    REJECT_MODEL = "REJECT_MODEL",
    DELETE_MODEL = "DELETE_MODEL",
    ASSIGN_MODEL_TO_AGENT = "ASSIGN_MODEL_TO_AGENT",
    REMOVE_MODEL_FROM_AGENT = "REMOVE_MODEL_FROM_AGENT",
    ADD_PLANNED_INCREASE = "ADD_PLANNED_INCREASE",
    REMOVE_PLANNED_INCREASE = "REMOVE_PLANNED_INCREASE",
    DEACTIVATE_MODEL = "DEACTIVATE_MODEL",
}

export const enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",
    LIKE = "LIKE",
    NOT_LIKE = "NOT_LIKE",
    STARTS_WITH = "STARTS_WITH",
    END_WITH = "END_WITH",
    IN = "IN",
    NOT_IN = "NOT_IN",
    GREATER_THAN = "GREATER_THAN",
    GREATER_OR_EQUAL_TO = "GREATER_OR_EQUAL_TO",
    LESS_THAN = "LESS_THAN",
    LESS_OR_EQUAL_TO = "LESS_OR_EQUAL_TO",
    BETWEEN = "BETWEEN",
}

export const enum FieldType {
    BOOLEAN = "BOOLEAN",
    CHAR = "CHAR",
    DATE = "DATE",
    INSTANT = "INSTANT",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    LONG = "LONG",
    STRING = "STRING",
    UUID = "UUID",
    ENUM_STRING = "ENUM_STRING",
}

export const enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum InvokeStatusType {
    NEW = "NEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
}

export const enum InvokeType {
    AgentRiskDebtLimitModelAssignment = "AgentRiskDebtLimitModelAssignment",
    AgentRiskDebtLimitModelRemoveAssignment = "AgentRiskDebtLimitModelRemoveAssignment",
    AgentRiskDownPaymentSet = "AgentRiskDownPaymentSet",
    AgentRiskTemporaryDebtLimitIncreaseAddition = "AgentRiskTemporaryDebtLimitIncreaseAddition",
    AgentRiskTemporaryDebtLimitIncreaseRemoval = "AgentRiskTemporaryDebtLimitIncreaseRemoval",
    DebtLimitModelCreation = "DebtLimitModelCreation",
    DebtLimitModelDeactivation = "DebtLimitModelDeactivation",
    DebtLimitModelPlanedDebtLimitIncreaseAddition = "DebtLimitModelPlanedDebtLimitIncreaseAddition",
    DebtLimitModelPlanedDebtLimitIncreaseRemoval = "DebtLimitModelPlanedDebtLimitIncreaseRemoval",
    AgentDebtRiskServiceSupportAddition = "AgentDebtRiskServiceSupportAddition",
    AgentDebtRiskServiceSupportRemoval = "AgentDebtRiskServiceSupportRemoval",
    DebtLimitModelDeletion = "DebtLimitModelDeletion",
}

export const enum MonthDayType {
    FirstDayOfMonth = "FirstDayOfMonth",
    FirstWorkingDayOfMonth = "FirstWorkingDayOfMonth",
    LastDayOfMonth = "LastDayOfMonth",
    LastWorkingDayOfMonth = "LastWorkingDayOfMonth",
    CertainDayOfMonth = "CertainDayOfMonth",
    DayInFirstWeekOfMonth = "DayInFirstWeekOfMonth",
    DayInSecondWeekOfMonth = "DayInSecondWeekOfMonth",
    DayInThirdWeekOfMonth = "DayInThirdWeekOfMonth",
    DayInFourthWeekOfMonth = "DayInFourthWeekOfMonth",
    DayInFifthWeekOfMonth = "DayInFifthWeekOfMonth",
}

export const enum Direction {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum NullHandling {
    NATIVE = "NATIVE",
    NULLS_FIRST = "NULLS_FIRST",
    NULLS_LAST = "NULLS_LAST",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
